import React from 'react'
import { Element } from '../../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { formatText, formatVal } from '../../../../../helpers/value'
import { isPercentFormat } from '../table/helper'
import classes from './classes.module.scss'

const LIST_TITLE = ['PORTFOLIO', 'MEDIAN_SCORE', 'INTERQUARTILE_RANGE']

export const CustomTooltip = ({ label, list, locale }) => {
  const renderItem = ({ label, median, rowId, range = [] }) => {
    const [min, max] = range
    const medianTitle = `${formatVal(median, locale)}${
      isPercentFormat(median, rowId) ? '%' : ''
    }`
    const minTitle = `${formatVal(min, locale)}${
      isPercentFormat(min, rowId) ? '%' : ''
    }`
    const maxTitle = `${formatVal(max, locale)}${
      isPercentFormat(max, rowId) ? '%' : ''
    }`

    return (
      <div className="dFlex gap1" style={{ marginBottom: 4 }}>
        <TooltipItem isI18n={false} title={label} />
        <TooltipItem
          className={classes.itemMedian}
          isI18n={false}
          title={medianTitle}
        />
        <TooltipItem
          isI18n={false}
          title={`(${minTitle} | ${maxTitle})`}
          lineClamp={2}
          className={classes.widthAuto}
        />
      </div>
    )
  }

  return (
    <Element>
      <div className="fstItalic mb1">{formatText(label)}</div>
      <div className="dFlex gap1" style={{ marginBottom: 4 }}>
        {LIST_TITLE.map((item, index) => {
          return (
            <TooltipItem
              key={item}
              title={`portfolio.finance.${item}`}
              className={`${index === 1 && classes.itemMedian}`}
            />
          )
        })}
      </div>
      {list.map((item, index) => {
        return <React.Fragment key={index}>{renderItem(item)}</React.Fragment>
      })}
    </Element>
  )
}

const TooltipItem = ({ title, className, isI18n = true, lineClamp = 1 }) => {
  return (
    <div className={[classes.titleTooltip, className].join(' ')}>
      <TextEllipsisStaticLine
        text={title}
        isI18n={isI18n}
        lineClamp={lineClamp}
      />
    </div>
  )
}
